// Number formats of Admin Analytics → Deflect (DAA-2-26). A figure that could not be computed
// (nothing to divide by) is null and reads "-".

// `accounting` is CommonJS: a default import is what both Vite and the Node test runner resolve.
import accounting from "accounting"

const { formatNumber } = accounting

const NO_FIGURE = "-"

const hasFigure = (value) => Number.isFinite(value)

// Rounded before it is signed, so -0.4 reads "0", not "-0" (`|| 0` turns -0 into 0).
const roundTo = (value, decimals) => Math.round(value * 10 ** decimals) / 10 ** decimals || 0

// "3,291"
export const formatCount = (value) =>
  hasFigure(value) ? formatNumber(roundTo(value, 0), 0, ",") : NO_FIGURE

// "73.8%"
export const formatShare = (value, decimals = 1) =>
  hasFigure(value) ? `${formatNumber(roundTo(value, decimals), decimals, ",")}%` : NO_FIGURE

// "$29,909", "$4.37", "-$5.50": each card states its decimals.
export const formatMoney = (value, decimals = 0) => {
  if (!hasFigure(value)) return NO_FIGURE

  const rounded = roundTo(value, decimals)
  const amount = `$${formatNumber(Math.abs(rounded), decimals, ",")}`

  return rounded < 0 ? `-${amount}` : amount
}

// "3.4"
export const formatDays = (value) =>
  hasFigure(value) ? formatNumber(roundTo(value, 1), 1, ",") : NO_FIGURE

// A days axis tick, "12d", and a days value in a chart tooltip, "3.4 d" (DAA-7-17).
export const formatDaysTick = (value) =>
  hasFigure(value) ? `${formatNumber(roundTo(value, 0), 0, ",")}d` : NO_FIGURE

export const formatDaysValue = (value) => (hasFigure(value) ? `${formatDays(value)} d` : NO_FIGURE)

// A KPI's comparison value, "4.1 days"; a missing one reads "-", without the unit (DAA-2-26).
export const formatDaysLong = (value, unit) =>
  hasFigure(value) ? `${formatDays(value)} ${unit}` : NO_FIGURE

// part ÷ whole × 100, or null when there is nothing to divide by.
export const toShare = (part, whole) => (whole ? (part / whole) * 100 : null)
